import angular from 'angular';
import swoaDeactivationDeactivation from './deactivation.component';

export default angular
  .module('swoa.deactivation', [
    swoaDeactivationDeactivation,
  ])
  .name;

